const FieldType = require('@/lib/CustomFields/FieldType');
const { calculateAgeFromDob } = require('@/functions/age');

/**
 * Displays a {FieldInstance} (supplied in the "instance" attribute).
 */
const fieldInstanceDirective = function () {
    return {
        restrict: 'E',

        scope: {
            instance: '=',
        },

        /**
         * @param {{instance: FieldInstance, mode: string, validate: function}} $scope
         */
        controller: function ($scope) {
            // Since PROP-1465 this is only used for displaying values and not editing then.
            if ($scope.instance.field.type === FieldType.DOB) {
                // Not in edit mode. Calculate the age for a date of birth field but don't show any errors.
                if ($scope.instance.value) {
                    try {
                        $scope.instance.age = calculateAgeFromDob($scope.instance.value);
                    } catch (e) {
                    }
                }
            }
        },

        template: function () {
            // Since PROP-1465 this is only used for displaying values and not editing then.
            return '<span class="field-value">{{ instance.getDisplayValue(true) }}</span>';
        },
    };
};

module.exports = fieldInstanceDirective;
